module.exports = __webpack_public_path__ + "static/media/Razor.a1594317.png";